import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import prettifyXml from "prettify-xml/dist";
import DropdownComponent from "../../Components/Dropdown/DropdownComponent";
import ConfirmationModal from "../../Components/Modal/Modal";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import Signifier from "../../Components/Signifier";
import { StyledTextField } from "../../Components/TextField/TextField";
import { RemoteAdFormat } from "../../Constants/DropdownConstants";
import {
  deleteOutboundTemplate,
  editOutboundTemplate,
  getOutboundFields,
} from "../../Services/API/OutboundTemplates";
import DraggableFeeds from "./DraggableFeeds";

function OutboundFeedTemplateDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingBottom: "20px",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
    },
    error: {
      color: theme.palette.error.main,
    },
    textField: {
      "& .Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        color: theme.palette.error.main,
      },
      "& .MuiInput-underline.Mui-error:after": {
        borderBottomColor: theme.palette.error.main,
      },
    },
    header: {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        marginTop: "10px",
      },
      display: "flex",
    },
    descLabel: {
      margin: "0px",
      fontWeight: "700",
      marginBottom: "10px",
    },
    descValue: {
      margin: "0px",
      marginLeft: "5px",
      marginRight: "20px",
    },
    descBlock: {
      display: "flex",
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showInputError, setShowInputError] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState(
    location.state === undefined ? "" : location.state.name
  );
  const [header, setHeader] = useState(
    location.state === undefined ? "" : location.state.includeHeaderData
  );
  const [custom, setCustom] = useState(
    location.state === undefined ? "" : location.state.isCustom
  );
  const [mainNodeName, setMainNodeName] = useState(
    location.state === undefined ? "" : location.state.mainNodeName
  );
  const [jobDataNodeName, setJobDataNodeName] = useState(
    location.state === undefined ? "" : location.state.jobDataNodeName
  );
  const [mainOuterWrapper, setMainOuterWrapper] = useState(
    location.state === undefined ||
      location.state.mainOuterWrapperString === undefined
      ? ""
      : location.state.mainOuterWrapperString
  );
  const [jobDataWrapper, setJobDataWrapper] = useState(
    location.state === undefined ||
      location.state.jobDataOuterWrapperString === undefined
      ? ""
      : location.state.jobDataOuterWrapperString
  );
  const [remoteFormat, setRemoteFormat] = useState(
    location.state === undefined ? "" : location.state.remoteFormat
  );
  const [fields, setFields] = useState([]);
  const [fieldsOrder, setFieldsOrder] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [deleted, setDeleted] = useState(false);

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const items = Array.from(fieldsOrder);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setFieldsOrder(items);
  }

  function handleInputChange(index, e) {
    const items = Array.from(fieldsOrder);
    items[index].val = e.target.value;
    setFieldsOrder(items);
  }

  const checkAllEntered = () => {
    if (!custom) {
      if (
        name === "" ||
        mainNodeName === "" ||
        jobDataNodeName === "" ||
        returnFields(fieldsOrder).length === 0
      ) {
        return false;
      }
    } else {
      if (name === "" || mainOuterWrapper === "" || jobDataWrapper === "") {
        return false;
      }
    }
    return true;
  };

  const returnFields = (order) => {
    var retVal = [];
    for (var i in order) {
      if (order[i].val !== "" && order[i].val !== undefined) {
        var newField = {
          FieldID: order[i].id,
          Name: order[i].val,
          Order: retVal.length + 1,
        };
        retVal.push(newField);
      }
    }
    return retVal;
  };

  const compare = (a, b) => {
    if (a.outboundFeedFields[0] === undefined) {
      return 1;
    }
    if (b.outboundFeedFields[0] === undefined) {
      return -1;
    }
    if (a.outboundFeedFields[0].order < b.outboundFeedFields[0].order) {
      return -1;
    }
    if (a.outboundFeedFields[0].order > b.outboundFeedFields[0].order) {
      return 1;
    }
    return 0;
  };

  const callAPI = (func, responseMessage) => {
    setProcessing(true);
    func.then((res) => {
      setShowSignifier(true);
      if (res) {
        setResponseMessage(responseMessage);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    });
  };

  const callDelete = async () => {
    await deleteOutboundTemplate(location.state.id).then((response) => {
      if (response) {
        setDeleted(true);
        return true;
      }
    });
    return true;
  };

  useEffect(() => {
    if (location.state !== undefined) {
      getOutboundFields(location.state.id).then((response) => {
        setFields(response);
      });
    }
  }, [location.state]);

  useEffect(() => {
    const items = Array.from(fields);
    items.sort((a, b) => {
      const order = compare(a, b);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    for (var i in items) {
      items[i].val =
        items[i].outboundFeedFields[0] !== undefined
          ? items[i].outboundFeedFields[0].name
          : "";
    }
    setFieldsOrder(items);
  }, [fields]);

  const data = {
    Id: location.state === undefined ? "" : location.state.id,
    Name: name,
    IsCustom: custom,
    IncludeHeaderData: header,
    MainNodeName: mainNodeName,
    JobDataNodeName: jobDataNodeName,
    MainOuterWrapperString: custom ? mainOuterWrapper : "",
    JobDataOuterWrapperString: custom ? jobDataWrapper : "",
    RemoteFormat: remoteFormat,
    OutboundFeedFields: custom ? [] : returnFields(fieldsOrder),
  };

  if (location.state === undefined) {
    return <Redirect to="/outboundfeeds" />;
  }

  if (deleted) {
    return <Redirect to="/outboundfeeds" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Outbound Feed Template</h1>
        <div className={classes.header}>
          <div className={classes.descBlock}>
            <p className={classes.descLabel}>DATE CREATED: </p>
            <p className={classes.descValue}>{location.state.dateCreated}</p>
          </div>
          <div className={classes.descBlock}>
            <p className={classes.descLabel}>DATE LAST UPDATED: </p>
            <p className={classes.descValue}>
              {location.state.dateLastUpdated}
            </p>
          </div>
        </div>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={6} item>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      value={name}
                      error={showInputError && name === ""}
                      className={classes.textField}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {showInputError && name === "" && (
                      <FormHelperText className={classes.error}>
                        Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DropdownComponent
                      currValue={RemoteAdFormat.find((obj) => {
                        return obj.Value === remoteFormat;
                      })}
                      items={RemoteAdFormat}
                      property={"Name"}
                      handleChange={(remoteAdObject) =>
                        setRemoteFormat(remoteAdObject.Value)
                      }
                      title="Select Remote Format"
                    />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={header}
                          onChange={() => setHeader(!header)}
                        />
                      }
                      label="Header Data"
                    />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={custom}
                          onChange={() => setCustom(!custom)}
                        />
                      }
                      label="Custom"
                    />
                  </Grid>
                  {custom ? (
                    <>
                      <Grid item xs={12} sm={12}>
                        <FormHelperText
                          style={{ marginTop: "20px", marginBottom: "-20px" }}
                        >
                          Available Fields
                        </FormHelperText>
                        <Button
                          style={{ marginTop: "20px" }}
                          type="submit"
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            setMainOuterWrapper(mainOuterWrapper + "[[data]]")
                          }
                        >
                          Job Data Container
                        </Button>
                        <StyledTextField
                          InputLabelProps={{
                            style: { color: "rgba(0,0,0,.6)" },
                          }}
                          placeholder="Main Outer Wrapper"
                          label="Main Outer Wrapper"
                          variant="standard"
                          fullWidth
                          required
                          multiline
                          rows={1}
                          rowsMax={20}
                          value={prettifyXml(mainOuterWrapper, { newline: '\n' })}
                          error={showInputError && mainOuterWrapper === ""}
                          className={classes.textField}
                          onChange={(e) => setMainOuterWrapper(e.target.value)}
                        />
                        {showInputError && mainOuterWrapper === "" && (
                          <FormHelperText className={classes.error}>
                            Main Outer Wrapper Required
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormHelperText
                          style={{ marginTop: "20px", marginBottom: "-20px" }}
                        >
                          Available Fields
                        </FormHelperText>
                      </Grid>
                      {fields.map((field, index) => (
                        <Grid item xs={6} sm={2}>
                          <Button
                            style={{
                              width: "100%",
                              height: "60px",
                              marginTop: "20px",
                            }}
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              setJobDataWrapper(
                                jobDataWrapper +
                                  "[[" +
                                  field.dataFieldName +
                                  "]]"
                              )
                            }
                          >
                            {field.name}
                          </Button>
                        </Grid>
                      ))}
                      <Grid item xs={12} sm={12}>
                        <StyledTextField
                          InputLabelProps={{
                            style: { color: "rgba(0,0,0,.6)" },
                          }}
                          placeholder="Job Data Wrapper"
                          label="Job Data Wrapper"
                          variant="standard"
                          fullWidth
                          required
                          multiline
                          rows={1}
                          rowsMax={20}
                          value={prettifyXml(jobDataWrapper, { newline: '\n' })}
                          error={showInputError && jobDataWrapper === ""}
                          className={classes.textField}
                          onChange={(e) => setJobDataWrapper(e.target.value)}
                        />
                        {showInputError && jobDataWrapper === "" && (
                          <FormHelperText className={classes.error}>
                            Job Data Wrapper Required
                          </FormHelperText>
                        )}
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={12} sm={3}>
                        <StyledTextField
                          InputLabelProps={{
                            style: { color: "rgba(0,0,0,.6)" },
                          }}
                          placeholder="Main Node Name"
                          label="Main Node Name"
                          variant="standard"
                          fullWidth
                          required
                          value={mainNodeName}
                          error={showInputError && mainNodeName === ""}
                          className={classes.textField}
                          onChange={(e) => setMainNodeName(e.target.value)}
                        />
                        {showInputError && mainNodeName === "" && (
                          <FormHelperText className={classes.error}>
                            Main Node Required
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <StyledTextField
                          InputLabelProps={{
                            style: { color: "rgba(0,0,0,.6)" },
                          }}
                          placeholder="Job Data Node Name"
                          label="Job Data Node Name"
                          variant="standard"
                          fullWidth
                          required
                          value={jobDataNodeName}
                          error={showInputError && jobDataNodeName === ""}
                          className={classes.textField}
                          onChange={(e) => setJobDataNodeName(e.target.value)}
                        />
                        {showInputError && jobDataNodeName === "" && (
                          <FormHelperText className={classes.error}>
                            Job Data Node Required
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <DropdownComponent
                          currValue={RemoteAdFormat.find((obj) => {
                            return obj.Value === remoteFormat;
                          })}
                          items={RemoteAdFormat}
                          property={"Name"}
                          handleChange={(remoteAdObject) =>
                            setRemoteFormat(remoteAdObject.Value)
                          }
                          title="Select Remote Format"
                        />
                      </Grid>
                      {showInputError &&
                        returnFields(fieldsOrder).length === 0 && (
                          <FormHelperText className={classes.error}>
                            At Least One Field Required
                          </FormHelperText>
                        )}
                      <DraggableFeeds
                        handleOnDragEnd={handleOnDragEnd}
                        items={fieldsOrder}
                        handleInputChange={handleInputChange}
                      />
                    </>
                  )}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        checkAllEntered()
                          ? callAPI(
                              editOutboundTemplate(data),
                              "Template Saved"
                            )
                          : setShowInputError(true)
                      }
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <div className={classes.sensitiveSection}>
              <Grid
                item
                xs={12}
                sm={12}
                container
                justifyContent="space-between"
              >
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpenModal(true)}
                >
                  Delete Template
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <ConfirmationModal
          question="Delete this template permanently?"
          func={() => callAPI(callDelete(), "Template Deleted")}
          closeModal={() => setOpenModal(false)}
          processing={processing}
        />
      </Dialog>
    </>
  );
}

export default OutboundFeedTemplateDetailed;
